import { apiGet, apiPost, apiPut, apiDelete } from "./client.js";

const BASE = "/api/v1/patients";

const addId = (item) => item ? { ...item, id: item._id || item.patientCode } : item;
const addIds = (items) => (items || []).map(addId);

export const listPatients = () => apiGet(BASE).then((d) => addIds(d.patients));
export const getPatient = (id) => apiGet(`${BASE}/${id}`).then(addId);
export const createPatient = (data) => apiPost(BASE, data).then(addId);
export const updatePatient = (id, data) => apiPut(`${BASE}/${id}`, data).then(addId);
export const deletePatient = (id) => apiDelete(`${BASE}/${id}`);
export const verifyPatient = (name, dob) => apiPost(`${BASE}/verify`, { name, dob });
